import { InjectionToken } from '@angular/core';
import { CountryIsoNumber } from '../models/country/country-iso-number.enum';

export const COUNTRY_ISO_NUMBER = new InjectionToken<CountryIsoNumber>(
  'Country ISO Number',
);
